"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityCoverMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
const opportunity_entity_1 = require("./opportunity.entity");
let OpportunityCoverMap = class OpportunityCoverMap {
    constructor(opportunityId, policyTypeId, coverId, mandateType, approvalRequired, coverName, coverDescription, displaySequence, displayCategory, coverTypeLid, inputType, inputLov, coversMeta) {
        this.opportunityId = opportunityId;
        this.policyTypeId = policyTypeId;
        this.coverId = coverId;
        this.mandateType = mandateType;
        this.approvalRequired = approvalRequired;
        this.coverName = coverName;
        this.coverDescription = coverDescription;
        this.displaySequence = displaySequence;
        this.displayCategory = displayCategory;
        this.coverTypeLid = coverTypeLid;
        this.inputType = inputType;
        this.inputLov = inputLov;
        this.coversMeta = coversMeta;
    }
};
exports.OpportunityCoverMap = OpportunityCoverMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityCoverMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityCoverMap.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_type_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityCoverMap.prototype, "policyTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityCoverMap.prototype, "coverId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "mandate_type",
        type: "varchar",
        length: 50,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityCoverMap.prototype, "mandateType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "approval_required",
        type: "varchar",
        length: 10,
        default: "No",
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityCoverMap.prototype, "approvalRequired", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_name", type: "varchar", length: 200, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityCoverMap.prototype, "coverName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityCoverMap.prototype, "coverDescription", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "display_sequence", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityCoverMap.prototype, "displaySequence", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "display_category",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityCoverMap.prototype, "displayCategory", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_type", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityCoverMap.prototype, "coverTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "input_type", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityCoverMap.prototype, "inputType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "input_lov", type: "jsonb", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], OpportunityCoverMap.prototype, "inputLov", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "covers_meta", type: "jsonb", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Record !== "undefined" && Record) === "function" ? _d : Object)
], OpportunityCoverMap.prototype, "coversMeta", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], OpportunityCoverMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        onUpdate: "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], OpportunityCoverMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "cover_type" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _g : Object)
], OpportunityCoverMap.prototype, "coverType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.covers),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _h : Object)
], OpportunityCoverMap.prototype, "opportunity", void 0);
exports.OpportunityCoverMap = OpportunityCoverMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_cover_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, String, String, String, String, Number, String, Number, String, typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object, typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object])
], OpportunityCoverMap);
